import { render, staticRenderFns } from "./GroupEquipamentsTable.vue?vue&type=template&id=ec30f3c0&scoped=true&"
import script from "./GroupEquipamentsTable.vue?vue&type=script&lang=js&"
export * from "./GroupEquipamentsTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupEquipamentsTable.vue?vue&type=style&index=0&id=ec30f3c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec30f3c0",
  null
  
)

export default component.exports